import(/* webpackMode: "eager" */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredAppsWeb"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\src\\components\\DeferredAppsWeb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredHomeHeroEffects"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\src\\components\\DeferredHomeHeroEffects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\src\\components\\Reveal.tsx");
